const storages = {
  daoAccessToken: 'dao_access_token',
  walletInfo: 'wallet-info',
};
export { storages };
